import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { regions, wines } from '../data/wines';
import { getVisibleWines } from '../utils/wineHelpers';
import ArrowLeftIcon from './icons/ArrowLeftIcon';

const RegionList = () => {
  const navigate = useNavigate();

  // Filtra apenas regiões que têm vinhos visíveis
  const availableRegions = useMemo(() => {
    const visibleWines = getVisibleWines(wines);
    return regions.filter(region => 
      visibleWines.some(wine => wine.region === region.name)
    );
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-wine-dark via-[#1e1a2e] to-wine-dark py-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex items-center mb-8">
          <button 
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-white hover:text-wine-gold transition-colors"
          >
            <ArrowLeftIcon />
            <span className="text-lg">Voltar</span>
          </button>
        </div>

        {/* Title */}
        <div className="text-center mb-12">
          <h1 className="text-white text-3xl md:text-4xl font-serif mb-4">
            Escolha a Região
          </h1>
          <p className="text-gray-400 text-lg">
            Explore vinhos das principais regiões vinícolas do mundo
          </p>
        </div>

        {/* Regions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {availableRegions.map((region) => (
            <div
              key={region.id}
              onClick={() => navigate(`/wines/region/${region.id}`)}
              className="cursor-pointer group"
            >
              <div className="bg-gradient-to-br from-[#2a2535] to-[#1a1625] rounded-2xl p-6 hover:scale-105 hover:shadow-xl hover:shadow-wine-gold/20 transition-all duration-300 border border-transparent hover:border-wine-gold/50 h-full">
                {/* Country Flag */}
                <div className="text-5xl mb-4 text-center group-hover:scale-110 transition-transform duration-300">
                  {region.flag}
                </div>
                
                {/* Region Info */}
                <h3 className="text-white text-xl font-serif text-center mb-2">
                  {region.name}
                </h3>
                <p className="text-wine-gold text-sm text-center mb-4 uppercase tracking-wide">
                  {region.country}
                </p>
                <p className="text-gray-400 text-sm text-center mb-4">
                  {region.description}
                </p>
                
                {/* Characteristics */}
                <div className="border-t border-gray-700 pt-4 mb-4">
                  <p className="text-gray-500 text-xs mb-2">
                    {region.characteristics}
                  </p>
                </div>

                {/* Highlights */}
                <div className="border-t border-gray-700 pt-4">
                  <p className="text-wine-gold text-xs uppercase tracking-wide mb-2 text-center">
                    Destaques:
                  </p>
                  <div className="flex flex-wrap gap-2 justify-center">
                    {region.highlights.map((highlight, index) => (
                      <span 
                        key={index}
                        className="text-xs bg-wine-dark px-2 py-1 rounded-full text-gray-300"
                      >
                        {highlight}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RegionList;

